export const UPSOLVE_INFO = {
  name: "Upsolve",
  address: {
    street1: "228 Park Ave S PMB 53933",
    city: "New York",
    state: "NY",
    zipcode: "10003-1502",
    country: "US",
  },
  phoneNumber: "347-850-2656",
  executiveDirector: "Jonathan Petts",
} as const;
